import { render, staticRenderFns } from "./BaseToolHeader.vue?vue&type=template&id=50921aa6&"
import script from "./BaseToolHeader.vue?vue&type=script&lang=js&"
export * from "./BaseToolHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseToolHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports